import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/styles.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/main.css';

const app = createApp(App);
app.config.globalProperties.$someGlobalProperty = 'value';

app.use(router);

app.mount('#app');
